import { useState } from "react";
import { useNavigate } from "react-router";
import { api } from "../../api/client";
import { useAuthStore } from "./authStore";
import { OperioBrand } from "~/ui/brand/OperioBrand";

export function LoginPage() {
  const navigate = useNavigate();
  const setAuth = useAuthStore((state) => state.setAuth);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    try {
      const response = await api.post<{ accessToken: string; email: string }>(
        "/auth/login",
        { email, password },
      );
      // Decode isAdmin from JWT payload
      const payloadB64 = response.accessToken.split(".")[1] ?? "";
      const payload = JSON.parse(
        atob(payloadB64.replace(/-/g, "+").replace(/_/g, "/")),
      );
      setAuth(
        response.accessToken,
        response.email || email.toLowerCase().trim(),
        !!(payload as any).isAdmin,
      );
      navigate("/app/customers");
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message || "Login fehlgeschlagen");
      } else {
        setError("Login fehlgeschlagen");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md rounded-lg bg-white p-8 shadow-md">
        <div className="mb-6"><OperioBrand centered subtitle="Anmelden" /></div>

        {error && (
          <div className="mb-4 rounded-md bg-red-50 p-4 text-sm text-red-700">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-700"
            >
              E-Mail
            </label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500"
              placeholder="name@example.com"
            />
          </div>

          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-700"
            >
              Passwort
            </label>
            <input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-gray-900 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full rounded-md bg-blue-600 px-4 py-2 font-medium text-white hover:bg-blue-700 disabled:opacity-50"
          >
            {isLoading ? "Wird angemeldet..." : "Anmelden"}
          </button>
        </form>

        <div className="mt-4 text-center">
          <button
            onClick={() => navigate("/forgot-password")}
            className="text-sm text-gray-500 hover:text-gray-700"
          >
            Passwort vergessen?
          </button>
        </div>

        <div className="mt-6 border-t border-gray-200 pt-6">
          <p className="mb-4 text-center text-sm text-gray-600">
            Noch kein Konto?
          </p>
          <button
            onClick={() => navigate("/request-account")}
            className="block w-full rounded-md border border-blue-600 px-4 py-2 text-center text-sm font-medium text-blue-600 hover:bg-blue-50"
          >
            Konto beantragen
          </button>
        </div>

        <div className="mt-4 text-center text-xs text-gray-500">
          <a href="/" className="hover:text-gray-700">
            ← Zurück zur Startseite
          </a>
        </div>
      </div>
    </div>
  );
}
